import { createContext } from "react";
import type { EmailTemplateData, ElementRef } from "./types";
import type { EmailTemplateItem } from "sj-ui-toolkit/src/api/admin/comms.email";

export interface RefMap {
  current: { [key: number]: ElementRef };
}

export interface EmailTemplateContextValue {
  data: RefMap;
  template: EmailTemplateData;
  onSave: (id: number, data: RefMap, template: EmailTemplateItem[]) => Promise<void>;
}

export const EmailTemplateContext = createContext<EmailTemplateContextValue | null>(null);
